<!-- Collect Quick Action Button -->
<template>
  <StyleColorQuickActionButton
    :style-color="styleColor"
    :style-color-source="styleColorSource"
    :style-color-source-index="styleColorSourceIndex"
    :size="size"
    @click="onClick">
    <SvgHeart :class="{ 'highlight': isCollected }"/>
  </StyleColorQuickActionButton>
</template>

<script setup>
import { useModals } from '@/composables/modals.js'
import StyleColorQuickActionButton from './StyleColorQuickActionButton.vue'
import SvgHeart from '@/components/global/svg/SvgHeart.vue'
import { useToastNotifications } from '@/composables/toastNotifications.js'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useClientStore } from '@shared/stores/client.js'
import { useClosetStore } from '@shared/stores/closet.js'
import useStyleColor from '@shared/composables/styleColor.js'

const props = defineProps({
  styleColor: {
    type: Object,
    required: true
  },
  /** @type {PropType<StyleColorSource>} */
  styleColorSource: {
    type: Object,
    required: true
  },
  styleColorSourceIndex: {
    type: Number,
    default: () => null
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})
const emit = defineEmits(['click'])

const modals = useModals()
const toastNotifications = useToastNotifications()

const { isCollected } = useStyleColor(() => props.styleColor)
const { isAuthenticated } = storeToRefs(useClientStore())
const closetStore = useClosetStore()
const { ratingsMap } = storeToRefs(closetStore)
const hasFavorites = computed(() => Object.values(ratingsMap.value).some(value => value === 1))

async function onClick (event) {
  if (!isAuthenticated.value || !hasFavorites.value) {
    modals.openClosetRatingInfoModal('favorite')
  }
  if (isAuthenticated.value) {
    const styleColorId = props.styleColor.id
    if (!isCollected.value) {
      // Show toast notification before dispatching so it shows up immediately.
      toastNotifications.showAddedToFavoritesToast(styleColorId)
      await closetStore.favorite({ styleColorId })
    } else {
      modals.openAddToCollectionModal(styleColorId)
    }
  }
  emit('click', event)
}
</script>

<style lang="scss" scoped>
.highlight {
  fill: $orchid;
}
</style>
